import {useMemo} from 'react';
import constants from './constants';

export const useEvents = dispatch => {
    const events = useMemo(() => {
        return {
            addCreatePaymentMethodData: (callback, priority = 10) => {
                const id = Math.floor(Math.random() * 1000);
                const action = {
                    id,
                    type: constants.CREATE_PAYMENT_DATA,
                    action: constants.ADD_ACTION,
                    callback,
                    priority
                };
                dispatch(action);

                return () => dispatch({
                    id,
                    type: constants.CREATE_PAYMENT_DATA,
                    action: constants.REMOVE_ACTION,
                });
            },
            addSuccessResponseData: (callback, priority = 10) => {
                const id = Math.floor(Math.random() * 1000);
                const action = {
                    id,
                    type: constants.ADD_SUCCESS_DATA,
                    action: constants.ADD_ACTION,
                    callback,
                    priority
                };
                dispatch(action);

                return () => dispatch({
                    id,
                    type: constants.ADD_SUCCESS_DATA,
                    action: constants.REMOVE_ACTION,
                });
            }
        }
    }, [dispatch]);

    return events;
}